import { render, staticRenderFns } from "./callbackUrl.vue?vue&type=template&id=b20fd4e8&scoped=true&"
import script from "./callbackUrl.vue?vue&type=script&lang=ts&"
export * from "./callbackUrl.vue?vue&type=script&lang=ts&"
import style0 from "./callbackUrl.vue?vue&type=style&index=0&id=b20fd4e8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20fd4e8",
  null
  
)

export default component.exports